<template>
  <div class="surety-manage">
    <el-dialog
      title="保证金管理"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="680px"
      :before-close="handleClose"
    >
      <el-row type="flex" align="middle">
        <p class="label">
          保证金余额
          <span class="sub-text">（保证金余额=基础保证金+订单保证金-扣减保证金）</span>
        </p>
        <el-button v-if="!showForm" type="primary" size="small" @click="toChange">调整保证金</el-button>
        <el-button size="small" @click="toViewLog">调整记录</el-button>
      </el-row>
      <p v-loading="loading" class="content">¥{{ bond }}</p>
      <!-- 调整 -->
      <el-form v-if="showForm" ref="manageFormEl" :model="form" :rules="rules" label-width="110px" size="small">
        <el-form-item label="调整方式：" prop="way">
          <el-select style="width: 320px" v-model="form.way" placeholder="请选择调整方式" @change="handleGetBondWay">
            <el-option label="增加保证金" :value="1" />
            <el-option label="减去保证金" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="调整类型：" prop="type">
          <el-select style="width: 320px" v-model="form.type" placeholder="请选择调整类型">
            <el-option v-for="item of bondWayList" :key="item.type" :label="item.name" :value="item.type" />
          </el-select>
        </el-form-item>
        <el-form-item label="调整金额：" prop="amount">
          <el-input v-model="form.amount" maxlength="200" style="width:320px" placeholder="请输入金额，不低于1元">
            <template slot="prepend">¥</template>
          </el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
            <el-input v-model.trim="form.remarks" type="textarea" maxlength="50" style="width:320px" placeholder="请输入备注" />
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <template v-if="showForm">
          <el-button :loading="saveing" size="small" type="primary" @click="handleAffirm">立即生效</el-button>
          <el-button size="small" @click="handleCloseForm">取 消</el-button>
        </template>
        <el-button v-else size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 调整记录 -->
    <el-dialog title="调整记录" :visible.sync="dialogVisibleRecord" :close-on-click-modal="false" :close-on-press-escape="false" width="700px" :before-close="handleCloseRecord" >
      <el-button size="small" type="primary" @click="handleExportRecord">导出</el-button>
      <el-table border v-loading="loading" :data="logList" style="width: 100%;margin-top: 10px">
        <el-table-column label="操作时间" align="center" prop="insertDate" width="180" />
        <el-table-column label="操作人" align="center" prop="insertName" />
        <el-table-column label="调整内容" align="center">
          <template v-slot="{ row }">
            <p>
              调整方式：
              <span v-if="row.way === 1">增加保证金</span>
              <span v-else-if="row.way === 2">减去保证金</span>
              <span v-else> -- </span>
            </p>
            <p>调整类型：{{ row.typeStr }}</p>
            <p>调整金额：{{ row.amount }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" prop="remarks">
          <template v-slot="{ row }">
            <span v-if="row.remarks">{{ row.remarks }}</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseRecord">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 导出 -->
    <FileExport ref="FileExport" />
  </div>
</template>

<script>
import { getCompanySurety, getBondWay, adjustBond, adjustBondLogList } from '@/api/organization';
import FileExport from "@/components/FileExport.vue";
import myPagination from "@/components/myPagination.vue";

export default {
  name: 'SuretyManage',

  components: { myPagination, FileExport },
  data () {
    const checkMin = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写调整金额!'));
      } else if (value < 1) {
        callback(new Error('调整金额不能小于1元!'));
      } else {
        callback();
      }
    }
    return {
      dialogVisible: false,
      loading: false,
      companyId: null,
      bond: 0,
      showForm: false,
      form: {
        way: '',
        type: '',
        amount: '',
        remarks: ''
      },
      bondWayList: [],
      rules: {
        way: [
          { required: true, message: "请选择调整方式!", trigger: 'change' }
        ],
        type: [
          { required: true, message: "请选择调整类型!", trigger: 'change' }
        ],
        amount: [
          { pattern: /^(\-)?\d+(\.\d{0,2})?$/, message: '请输入正确数字,', trigger: 'blur' },
          { validator: checkMin, trigger: 'blur' },
        ]
      },
      saveing: false,
      dialogVisibleRecord: false,
      logList: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  methods: {
    init (payload) {
      this.loading = true
      this.companyId = payload.id
      this.handleGetCompanySurety(payload.id)
      this.dialogVisible = true
    },
    handleGetCompanySurety (companyId) {
      getCompanySurety({ companyId }).then(({ code, data }) => {
        if (code === 0) {
          this.bond = data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    toChange () {
      this.showForm = true
    },
    toViewLog () {
      this.handleAdjustBondLogList()
      this.dialogVisibleRecord = true
    },
    // 导出调整记录
    handleExportRecord () {
      const params = {
        companyId: this.companyId
      }
      this.$refs.FileExport.init(
        params, // 搜索表单参数
        "jsw-order-provider", // 后端对应业务线服务
        "/order/adm/bond/export", // 导出-对应的接口
        1, //  状态：0get、1post
        "调整记录.xlsx" //文件名称
      );
    },
    handleAffirm () {
      this.$refs.manageFormEl.validate(valid => {
        if (valid) {
          this.saveing = true
          const params = {
            companyId: this.companyId,
            ...this.form
          }
          adjustBond(params).then(({ code }) => {
            if (code === 0) {
              this.$message.success('调整保证金成功!')
              this.handleGetCompanySurety(this.companyId)
              this.handleCloseForm()
            }
          }).finally(() => {
            this.saveing = false
          })
        }
      })
    },
    // 获取调整记录
    handleAdjustBondLogList () {
      this.loading = true
      const params = {
        companyId: this.companyId,
        ...this.pageInfo
      }
      adjustBondLogList(params).then(({ code, data }) => {
        if (code === 0) {
          this.logList = data.records
          this.pageInfo.total = +data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleGetBondWay (way) {
      this.form.type = ''
      this.bondWayList = []
      getBondWay({ way }).then(({ code, data }) => {
        if (code === 0) {
          this.bondWayList = data
        }
      })
    },
    handleClose () {
      this.dialogVisible = false
    },
    handleCloseForm () {
      this.$refs.manageFormEl && this.$refs.manageFormEl.resetFields()
      this.bondWayList = []
      this.showForm = false
    },
    handleCloseRecord () {
      this.logList = []
      this.pageInfo = this.$options.data().pageInfo
      this.dialogVisibleRecord = false
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.handleAdjustBondLogList()
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val
      this.handleAdjustBondLogList()
    },
  }
}
</script>

<style lang="scss" scoped>
.surety-manage {
  .label {
    margin-right: 32px;
    font-size: 18px;
    font-weight: bold;
    .sub-text {
      font-size: 12px;
      font-weight: normal;
      color: #999999;
    }
  }
  .content {
    font-weight: bold;
    margin-top: 12px;
    font-size: 24px;
    color: #52c41a;
  }
}
</style>
